import { render, staticRenderFns } from "./passwordAuth.vue?vue&type=template&id=c408ccb4&scoped=true&"
import script from "./passwordAuth.vue?vue&type=script&lang=js&"
export * from "./passwordAuth.vue?vue&type=script&lang=js&"
import style0 from "./passwordAuth.vue?vue&type=style&index=0&id=c408ccb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c408ccb4",
  null
  
)

export default component.exports